export const mockEligibilitySubscriptionsList = {
  _links: {
    current: 'https://staging-api.poweredbypercent.com/v1/admin/eligibility-subscriptions?pageSize=0&status=pending'
  },
  data: [],
  totalResults: 169,
  pageSize: 0,
  object: 'eligibility_subscription_admin'
}
